<template>
  <Row>
    <Col :md='24' class="funcs">
    <slot />
    </Col>
  </Row>
</template>

<script>
export default {
  name: 'TableFuncs',
  props: {
    
  },
 
  methods: {
   
  }
}
</script>
<style lang="less" scoped>
	.funcs{
		display: flex;
		justify-content: flex-start;
		flex-wrap:wrap;
		min-height: 60px;
		padding: 10px 0px;
	}
</style>